export function parseVersion(output: string): string | undefined {
  return output.match(/\b(\d+\.\d+\.\d+)\b/)?.[1]
}

/** Compares the three numeric segments only; prerelease tags are ignored. */
export function compareVersions(left: string, right: string): number {
  const leftParts = left.split('.').map(Number)
  const rightParts = right.split('.').map(Number)
  for (let index = 0; index < 3; index++) {
    const difference = (leftParts[index] ?? 0) - (rightParts[index] ?? 0)
    if (difference !== 0) return difference
  }
  return 0
}

export function matchesVersionSpec(spec: string, version: string): boolean {
  return (
    spec === version || spec === `^${version}` || spec === `~${version}` || spec === `=${version}`
  )
}
